import React from "react";
import { IonImg, IonLabel } from "@ionic/react";
import {
	APPLE_APP_STORE_LINK,
	GET_THE_APP,
	GOOGLE_PLAY_STORE_LINK,
} from "../../constants";
import "../../global.scss";

export const GetApp: React.FC = () => {
	return (
		<div className="login34">
			<img src="/images/appvector1.svg" style={{ height: 70 }} />
			<div className="login35">
				<IonLabel className="login36 marginL_0">{GET_THE_APP}</IonLabel>
				<div className="login37">
					<img
						src="/images/appStore.png"
						className="login38"
						// onClick={ () => window.open(APPLE_APP_STORE_LINK, "_blank")}
					/>
					<img
						src="/images/googleStore.png"
						className="login38"
						// onClick={ () => window.open(GOOGLE_PLAY_STORE_LINK, "_blank")}
					/>
				</div>
			</div>
		</div>
	);
};
